<div [ngClass]="{teamMember:true, opened:group.expanded, partOfTheTeam: alreadyMember}">
  <div class="clickableTitle" (click)="expandToggle()">
    <div class="memberData withAvatar">
      <figure>
        <img
          [src]="'/assets/img/icons/svg/Weave_Group_Icon.svg'"
          alt="{{group.name}}">
        </figure>
        <div class="wrappingName">
          {{group.name}}
          @if (isSearch && !hideWordSearched) {
            <div class="searchedGroupMembers">
              @if (displayUserName) {
                <span>{{displayUserName}} @if (othersCount>0) {
                  <span>& {{othersCount}} others</span>
                }</span>
              }
              @if (!displayUserName) {
                <span>{{othersCount}} members</span>
              }
            </div>
          }
        </div>
      </div>
    </div>
    @if (!alreadyMember) {
      <button class="expander" (click)="expandToggle()">
        @if (group.expanded) {
          <i class="material-icons">expand_less</i>
        }
        @if (!group.expanded) {
          <i class="material-icons">expand_more</i>
        }
      </button>
    }
    @if (group.expanded) {
      <div class="memberList">
        @if (!alreadyMember && isSearch && canEdit) {
          <button class="button" (click)="addGroup()">Add Group</button>
        }
        <h5 class="groupMembersTitle pageHeader">Group ({{group.members.length}}):</h5>
        <ul>
          @for (member of group.members; track member) {
            <li >
              <app-member [member]="member" [hideFunctions]="true" [hideAvatar]="false"></app-member>
            </li>
          }
        </ul>
        @if ((alreadyMember && canEdit) || (!isSearch && canEdit)) {
          <button class="button" (click)="deleteGroup()">Remove Group</button>
        }
      </div>
    }
  </div>
